import React from "react";
import { Moment } from "moment";
import AreaVideoSidebar from "./UIComponents/Sidebar/AreaVideoSidebar";
import CreeksSidebar from "./UIComponents/Sidebar/CreekSidebar";
import GuidesSidebar from "./UIComponents/Sidebar/GuidesSidebar";
import SidebarContent from "./UIComponents/Sidebar/SidebarContent";
import SpotDescription from "./UIComponents/Spotdescription/SpotDescription";
import TouristOfficeSidebar from "./UIComponents/Sidebar/TouristOfficeSidebar";

type LeftSidebarTypes =
  | "spot"
  | "creeks"
  | "touristOffices"
  | "boatRental"
  | "shops"
  | "accommodation"
  | "guides"
  | "areaVideo";

//This is a factory function that returns a component based on the type of the sidebar
export function SidebarFactory(props: {
  type: LeftSidebarTypes;
  data: any;
  currentTime: Moment;
}) {
  if (!props.data) return null;
  switch (props.type) {
    case "spot":
      return (
        <SpotDescription spot={props.data} currentTime={props.currentTime} />
      );
    case "creeks":
      return <CreeksSidebar feature={props.data} />;
    case "touristOffices":
      return <TouristOfficeSidebar feature={props.data} />;
    case "boatRental":
    case "shops":
    case "accommodation":
      return <SidebarContent data={props.data} />;
    case "guides":
      return <GuidesSidebar data={props.data} />;
    case "areaVideo":
      return <AreaVideoSidebar data={props.data} />;
    default:
      return null;
  }
}
